export { selectHasUnlimitedChat, selectHasVoiceAccess } from './selectors'
export { setOraclePersona } from './actions'

export const PERSONALITY_ARCHITECT_ID = 1
export const PERSONALITY_SAGE_ID = 2
export const DEFAULT_PERSONALITY_ID = PERSONALITY_SAGE_ID
